<app-booking *ngIf="ApptsByRoom==='false'"></app-booking>
<app-booking-by-room *ngIf="ApptsByRoom==='true'"></app-booking-by-room>